import BrowserLanguage from 'in-browser-language'
import Cookies from 'js-cookie'
import _ from 'lodash'
import Settings from '@/config/Settings'

// Cookies.remove(Settings.cookies.lang)

let defaultLanguage = Cookies.get(Settings.cookies.lang) || BrowserLanguage.pick(Settings.locale, _.head(Settings.locale))

defaultLanguage = _.findKey(Settings.onfUrl, url => url == window.location.hostname) || 'en'

export default defaultLanguage



// WEBPACK FOOTER //
// ./src/core/js/DefaultLanguage.js